import React from 'react';
import { connect } from 'react-redux';
import { formatDate } from 'helpers/DateHelper';
import FormElement from 'components/FormElement';

const DeviceInfoDates = ({ request }) => {
  const {
    saveDate,
    submissionDate,
    completeDate,
    isSaved,
    isPending,
    isUnderReview,
    isApproved
  } = request;

  if (request.id > 0) {
    return [
      <FormElement
        id="saveDate"
        label="Date Saved"
        value={formatDate(saveDate)}
        show={isSaved}
        key={1}
      />,
      <FormElement
        id="submitDate"
        label="Date Submitted"
        value={formatDate(submissionDate)}
        show={isPending || isUnderReview || isApproved}
        key={2}
      />,
      <FormElement
        id="certifiedDate"
        label="Date Certified"
        value={formatDate(completeDate)}
        show={isApproved}
        key={3}
      />
    ];
  }

  return null;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(DeviceInfoDates);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/DeviceInfoDates.js